import { Form, message, Select } from 'antd';
import { DefaultOptionType } from 'antd/es/select';
import React from 'react';
import FormComponent from 'src/app/components/FormComponent/FormComponent';
import { IFormProps } from 'src/app/forms/form.config';
import { getEnumSelectOptions } from 'src/app/helpers/enum.helper';
import {
  useGetModulesAndMachinesQuery,
  useGetModulesByMachineQuery,
  useStartModuleMutation,
} from 'src/app/redux/controlPanel/controlPanelSlice';
import { INTERESTS_WHITELIST } from 'src/configs/system.config';
import { InterestsTypes } from 'src/enums/interests.enum';

const StartModuleForm: React.FC<IFormProps> = ({ form }) => {
  const selectedMachine = Form.useWatch('machineIp', form);
  const { data: modulesAndMachines } = useGetModulesAndMachinesQuery({ name: 'modules and Machines' });
  const { data: modules } = useGetModulesByMachineQuery(
    { machineIp: selectedMachine },
    { skip: !selectedMachine, refetchOnMountOrArgChange: true },
  );

  const [startModule] = useStartModuleMutation();

  const machineOptions: DefaultOptionType[] =
    modulesAndMachines?.machine?.map((m) => ({ label: m.ipAddress, value: m.ipAddress })) || [];

  const moduleOptions: DefaultOptionType[] = modules?.map((module) => ({ label: module, value: module })) || [];

  const onFinish = (values: any) => {
    startModule(values)
      .unwrap()
      .then(() => message.success('Module started successfully'))
      .catch((error) => {
        console.log('error', error);
        message.error('Module can not be started');
      });
  };

  return (
    <FormComponent options={{ form, onFinish }}>
      <Form.Item label="Machine" name="machineIp" rules={[{ required: true }]}>
        <Select options={machineOptions} variant="borderless" />
      </Form.Item>
      <Form.Item label="Module" name="moduleName" rules={[{ required: true }]}>
        <Select variant="borderless" options={moduleOptions} />
      </Form.Item>
      <Form.Item
        noStyle
        shouldUpdate={(prevValues, currentValues) => {
          return prevValues.moduleName !== currentValues.moduleName;
        }}
      >
        {({ getFieldValue }) => {
          const selectedModuleName = getFieldValue('moduleName') as string;
          if (selectedModuleName && selectedModuleName.startsWith('nginrCollectorBackendManual'))
            return (
              <Form.Item name="interestType" rules={[{ required: true }]} label="Interest Types">
                <Select
                  mode="multiple"
                  variant="borderless"
                  options={getEnumSelectOptions(InterestsTypes, INTERESTS_WHITELIST())}
                />
              </Form.Item>
            );
        }}
      </Form.Item>
    </FormComponent>
  );
};

export default StartModuleForm;
